import React, { useEffect, useState } from "react";

import TestMatchTabs from "../cricket/TestMatchTabs";
import NoDataFound from "../common/NoDataFound";
import CricketPlayerTable from "./CricketPlayerTable";
import { loadStyles } from "../../utils/cssLoader";

const CricketTeamTable = ({ ServerData,
  loadCSS = true,
  dataClient = false,
  title, }) => {

  const [clientData, setClientData] = useState(null);
  const data = dataClient ? clientData?.data : ServerData?.data;


  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("cricketmatch");
    }
  }, [loadCSS]);
  const teams = data?.teams;
  const team_squards = data?.team_squards;
  const team1Id = data?.teams?.team1?.id;
  const team2Id = data?.teams?.team2?.id;
  const team1Players = team_squards
    ?.filter((player) => player.team_id === team1Id)
    ?.map((player) => player?.player);

  const team2Players = team_squards
    ?.filter((player) => player.team_id === team2Id)
    ?.map((player) => player?.player);

  const items = [
    {
      value: "Playing Xl",
      label: "Playing Xl",
    },
    {
      value: "Squad",
      label: "Squad",
    },
  ].filter(Boolean);
  const [active, setActive] = useState("Playing Xl");

  return (
    <>
      {title ? <h1>{title}</h1> : null}
      <TestMatchTabs items={items} activeItem={active} onClick={setActive} />
      {data?.team_squards?.length ? (
        <div className="global_table striped ft_player_team">
          <table>
            <thead>
              <tr>
                <th>{data?.teams?.team1?.code}</th>
                <th>{data?.teams?.team2?.code}</th>
              </tr>
            </thead>
            {active === "Playing Xl" ? (
              <>
                {" "}
                <CricketPlayerTable
                  team1Players={teams?.team1?.cricLineups}
                  team2Players={teams?.team2?.cricLineups}
                />{" "}
              </>
            ) : (
              <CricketPlayerTable
                team1Players={team1Players}
                team2Players={team2Players}
              />
            )}
          </table>
        </div>
      ) : (
        <NoDataFound />
      )}
    </>
  );
};

export default CricketTeamTable;
